$(document).ready(function () {
	'use strict';
	/* Initiate the Bootstrap Material Design */
	$('body').bootstrapMaterialDesign();

	/* Defining a utility timer iTimer*/
	var iTimer;

	/* Enabling tool tips */
	
	$('[data-toggle="skye-tooltip"]').tooltip();
	
	$('[data-toggle="course-flag-popover"]').popover({ trigger: 'hover' });

	/* Extend the functionality of the course flag popover for accessibility reasons */
	$('[data-toggle="course-flag-popover"]').focus(function(){
		$(this).mouseover();
	
	});
	$('[data-toggle="course-flag-popover"]').blur(function(){
		$(this).mouseout();
	
	});
	/* Popover located in the shopping cart modification area. */
	$('[ data-toggle="modifycart" ]').popover();

	/* Prevent default on the skye-cart Remove item anchor tag */	
	$(".remove-item").click(function(event){
		event.preventDefault();
	});
	
	/* Category Result Item Flag Descriptions for Hover-Over START HERE */
	var catgFlagDesc = {
		Certificate: 'Add this comprehensive “Certificate of Achievement” to your r&#233sum&#233 to demonstrate your credibility and mastery of this material.',
		ExamPrep: 'This course aligns to a third-party certification exam and seeks to prepare you to pass that certification exam on the first try.',
		Scenario: 'This course contains a series of real-world scenarios or case studies and seeks to teach through the practical application of concepts.',
		PracticeExam: 'This course contains practice exams and exam study strategies.',
		Simulation: 'This course uses characters and decision points to simulate a real-world environment and teach the practical application of concepts.'
	}; 
	
	/* FLAG Buttons on PRODUCT PAGE and CertSuite pages */
	/* Get Buttons with Scenario Flag or Text from the product page (flag id 1) */
	var CertButton = $('.btn.flag-id-1');
		CertButton.attr('data-content' , catgFlagDesc.Certificate);
		CertButton.attr('title' , 'Certificate');
		CertButton.attr('data-original-title' , 'Certificate');
	var ariaTextCert = "Certificate Course, " + catgFlagDesc.Certificate;
		CertButton.attr('aria-label' , ariaTextCert );

	/* Get Buttons with ExamPrep Flag or Text from the product page flag id 2) */
	var ExamPrepButton = $('.btn.flag-id-2');
		ExamPrepButton.attr('data-content' , catgFlagDesc.ExamPrep);
		ExamPrepButton.attr('title' , 'Exam Prep');
		ExamPrepButton.attr('data-original-title' , 'Exam Prep');
	var ariaTextExamPrep = "Exam Prep Course, " + catgFlagDesc.ExamPrep;
		ExamPrepButton.attr('aria-label' , ariaTextExamPrep);
	
	/* Get Buttons with Practice Exam Flag or Text from the product page flag id 3) */
	var PracExamButton = $('.btn.flag-id-3');
		PracExamButton.attr('data-content' , catgFlagDesc.PracticeExam);
		PracExamButton.attr('title' , 'Practice Exam');
		PracExamButton.attr('data-original-title' , 'Practice Exam');
	var ariaTextPrac = "Practice Exam Course, " + catgFlagDesc.PracticeExam;
		PracExamButton.attr('aria-label' , ariaTextPrac );

	/* Get Buttons with Scenario Flag or Text from the product page flag id 4) */
	var ScenarioButton = $('.btn.flag-id-4');
		ScenarioButton.attr('data-content' , catgFlagDesc.Scenario);
		ScenarioButton.attr('title' , 'Scenario');
		ScenarioButton.attr('data-original-title' , 'Scenario');
	var ariaTextScene = "Scenario Course, " + catgFlagDesc.Scenario;
		ScenarioButton.attr('aria-label' , ariaTextScene);
	
	/* Get Buttons with Simulation Flag or Text from the product page flag id 5) */
	var SimulationButton = $('.btn.flag-id-5');
		SimulationButton.attr('data-content' , catgFlagDesc.Simulation);
		SimulationButton.attr('title' , 'Simulation');
		SimulationButton.attr('data-original-title' , 'Simulation');
	var ariaTextSim = "Simulation Course, " + catgFlagDesc.Simulation;
		SimulationButton.attr('aria-label' , ariaTextSim );
	/* END Product BUTTONS ON PRODUCT PAGE and CertSuite */
	
	/* Get All Results that have a ExamPrep Flag */
	var CatgExamPrepFlag = $('.skye-catg-result.container.decal.exam .listing-decal');
		CatgExamPrepFlag.attr('data-content' , catgFlagDesc.ExamPrep);
		CatgExamPrepFlag.attr('title' , 'Exam Prep');
		CatgExamPrepFlag.attr('data-original-title' , 'Exam Prep');
	var ariaFlagExamPrep = "Exam Prep Course, " + CatgExamPrepFlag.ExamPrep;
		CatgExamPrepFlag.attr('aria-label' , ariaFlagExamPrep);
	
	/* Get All Results that have a Certifications Flag */
	var CatgCertFlag = $('.skye-catg-result.container.decal.cert .listing-decal');
		CatgCertFlag.attr('data-content' , catgFlagDesc.Certificate);
		CatgCertFlag.attr('title' , 'Certificate');
		CatgCertFlag.attr('data-original-title' , 'Certificate');
	var ariaFlagCert = "Certificate Course, " + CatgCertFlag.Certificate;
		CatgCertFlag.attr('aria-label' , ariaFlagCert);
	
	/* Get All Results that have a Scenario Flag */
	var CatgScenarioFlag = $('.skye-catg-result.container.decal.scene .listing-decal');
		CatgScenarioFlag.attr('data-content' , catgFlagDesc.Scenario);
		CatgScenarioFlag.attr('title' , 'Scenario');
		CatgScenarioFlag.attr('data-original-title' , 'Scenario');
	var ariaFlagTextScene = "Scenario Course, " + CatgScenarioFlag.Scenario;
		CatgScenarioFlag.attr('aria-label' , ariaFlagTextScene);
	
	/* Get All Results that have a Practice Exam Flag */
	var CatgPracExamFlag = $('.skye-catg-result.container.decal.prac .listing-decal');
		CatgPracExamFlag.attr('data-content' , catgFlagDesc.PracticeExam);
		CatgPracExamFlag.attr('title' ,'Practice Exam');
		CatgPracExamFlag.attr('data-original-title' ,'Practice Exam');
	var ariaFlagTextPracExam = "Practice Exam Course, " + CatgPracExamFlag.PracticeExam;
		CatgPracExamFlag.attr('aria-label' , ariaFlagTextPracExam);
	/* Category Result Item Flag Descriptions for Hover-Over ENDS HERE */
	
	/* Main navigation bar placeholder interaction modification */
	$('#navSearch').focus(function(){
	$(this).attr('placeholder' , '');						  
	});
	
	$('#navSearch').blur(function(){
	$(this).attr('placeholder' , 'Search courses...');						  
	});
	
});
